var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.hasAccess("PRIVILEGE_ORDER_LIST_MY") || this.hasAccess("PRIVILEGE_ORDER_LIST_ALL"))?_c('ordersList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }